<div class="container">
  <div class="d-flex flex-column">
    <h1 class="text-secondary text-center">
      <strong class="text-dark">Oups, </strong>vous n'avez pas le droit d'accéder à Insertis. Veuillez contacter votre administrateur.
      <a routerLink="/login">Accueil</a>
    </h1>
  </div>
</div>
